module.exports = __webpack_public_path__ + "static/media/8.7a6391ad.JPG";